import React, { useState } from "react";
import { LicenseActivation } from "../Login/LicenseWizard";
import Modal from "../Common/Modal";
import Loading from "../../Loading";
import LicenseRequestModal from "../Login/LicenseRequestModal";

export type LicenseAction = "request" | "activation";

type Props = {
  show: boolean;
  onHide: () => void;
  licenseAction: LicenseAction;
};

export default function LicenseActivatonModal({
  show,
  onHide,
  licenseAction,
}: Props) {
  const [showLoading, setShowLoading] = useState(false);

  return (
    <Modal
      show={show}
      onHide={onHide}
      style={{
        background: "#FFFFFF",
        border: "1px solid #F7A246",
        boxSizing: "border-box",
        borderRadius: 6,
        textAlign: "left",
        paddingLeft: 24,
        paddingRight: 24,
        paddingBottom: 14,
        paddingTop: 30,
      }}
    >
      {licenseAction === "request" && (
        <LicenseRequestModal
          onClose={onHide}
          onStartRequest={() => setShowLoading(true)}
          onStopRequest={() => setShowLoading(false)}
        />
      )}
      {licenseAction === "activation" && (
        <LicenseActivation
          onClose={onHide}
          onStartActivation={() => setShowLoading(true)}
          onStopActivation={() => setShowLoading(false)}
        />
      )}
      {showLoading && <Loading />}
    </Modal>
  );
}
